const store = {
  state: {
    selected: [],
  },
  mutations: {
    setSelectedSubscriptions(s, subscriptions) {
      s.selected = subscriptions;
    },
  },
  getters: {
    selectedSubscriptions: (s) => s.selected,
  },
};

export default store;
